<template>
  <Swiper ref="productsSlider" v-bind="options">
    <slot></slot>
  </Swiper>
</template>

<script setup lang="ts">
import { Swiper } from 'swiper/vue'
import { Mousewheel } from 'swiper/modules'
import 'swiper/css'

const productsSlider = ref<any>(null)
const options = computed(() => {
  return {
    modules: [Mousewheel],
    loop: false,
    slidesPerView: 'auto' as const,
    equalHeight: true,
    spaceBetween: 8,
    slidesOffsetBefore: 16, // Add 16px space before the first slide
    slidesOffsetAfter: 16, // Add 16px space after the last slide
    mousewheel: {
      forceToAxis: true,
    },
  }
})
</script>

<style lang="postcss" scoped>
.swiper,
.swiper-initialized,
.swiper-horizontal {
  overflow: hidden !important;

  /* Full-width on mobile - negative margins to counteract parent padding */
  @apply -mx-4 md:mx-0;

  :deep(.swiper-wrapper) {
    height: auto !important;
  }
}
</style>
